import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { BaseFormControlComponent } from '../../form-control/base-form-control.component';

@Component({
  selector: 'air-numeric-control',
  templateUrl: './numeric-control.component.html',
  imports: [ReactiveFormsModule]
})
export class NumericControlComponent extends BaseFormControlComponent implements OnInit, OnDestroy {}
